import React from "react";
import BulletInactive from "@images/BlogBulletInactive.svg";
import slugify from "slugify";

export type TableOfContentsType = {
  contents: {
    sectionName: string;
  }[];
  contentsLabel: string;
};
export const TableOfContentsCard = ({
  contents,
  contentsLabel,
}: TableOfContentsType) => {
  if (!contents?.length) return null;
  return (
    <div className="rounded-xl border-2 bg-white px-6 py-8">
      <h2 className="mb-3 font-sans text-xl">{contentsLabel}</h2>
      <div className="flex justify-start space-x-3">
        <div className="mt-2 flex flex-col gap-4 pl-0">
          {contents.map(section => (
            <div className="flex flex-row gap-x-3" key={section.sectionName}>
              {/* Bullet */}
              <img
                className="mt-1 mb-0 h-3 w-3 self-start"
                src={BulletInactive}
                alt="list bullet"
              />
              <p
                className="author-card-rale m-0 cursor-pointer text-gray-500"
                onClick={() => {
                  /** Scroll to title */
                  if (document && document !== null) {
                    const id = `#${slugify(section.sectionName, {
                      strict: true,
                      lower: true,
                    })}`;
                    document?.querySelector(id)?.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }
                }}
              >
                {section.sectionName}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
